import React, { useMemo } from 'react';
import textAdditionalClassName from '../../../helpers/utils/TextAdditionalClassName';

interface BodyLargeSemiboldProps {
  children: React.ReactNode;
  className?: string;
  maxLines?: number;
  isClamp?: boolean;
  style?: React.CSSProperties;
  textBreak?: 'words' | 'characters' | 'normal';
  overflow?: 'hidden' | 'visible';
}

const BodyLargeSemibold = ({
  children,
  maxLines = 2,
  isClamp = false,
  className = '',
  style = {},
  textBreak = 'words',
  overflow = 'hidden',
  ...props
}: BodyLargeSemiboldProps & React.ComponentProps<'p'>) => {
  const lineClampStyle: React.CSSProperties = isClamp
    ? {
      WebkitLineClamp: maxLines,
      WebkitBoxOrient: 'vertical',
      display: '-webkit-box',
    }
    : {};

  const additionalClassName = useMemo(
    () => textAdditionalClassName(textBreak, overflow),
    [textBreak, overflow]
  );

  return (
    <p
      style={{ ...lineClampStyle, ...style }}
      className={`text-[16px] leading-[24px] text-black90 font-semibold ${additionalClassName} ${className}`}
      {...props}
    >
      {children}
    </p>
  );
};

export default BodyLargeSemibold;
